module.exports = __webpack_public_path__ + "static/media/allFilterIconBlack.5522a2dc.svg";